import React from "react";
import StakingNav from "../../components/staking-Nav/StakingNav";
import StakingHero from "../../components/staking-Hero/StakingHero";
import StakingAbout from "../../components/staking-About/StakingAbout";
import Footer from "../../components/footer/Footer";
import StakingScenarios from "../../components/stakingScenarios/StakingScenarios";

function Staking() {
  return (
    <div>
      <StakingNav />
      <StakingHero />
      <StakingAbout />
      <StakingScenarios />
      <Footer />
    </div>
  );
}

export default Staking;
